import convertNode from "../convertNode";

export default function parseDescriptionList(xmlNode) {
  return {
    type: "definition_list",
    content: Array.from(xmlNode.children).map(convertNode),
  };
}
